import { useSetCredentials, useCredentials } from "../components/CredentialsProvider.js";
import { useHistory } from "../components/HistoryProvider.js";
import { useSecurityConfig } from "../components/SecurityConfigProvider.js";
import { logout } from "../services/api.js";
import "react/jsx-runtime";
import "react";
import "../config.js";
import "../helpers/time.js";
import "./useStickyState.js";
import "axios";
import "../helpers/credentials.js";
import "../helpers/headers.js";
var PatientLogoutKind = /* @__PURE__ */ ((PatientLogoutKind2) => {
  PatientLogoutKind2["MANUAL"] = "PATIENT_MANUAL_LOGOUT";
  PatientLogoutKind2["AUTO"] = "PATIENT_AUTO_LOGOUT";
  PatientLogoutKind2["EXPIRED"] = "PATIENT_TOKEN_EXPIRED";
  PatientLogoutKind2["DELETION"] = "PATIENT_USER_ACCOUNT_DELETION";
  return PatientLogoutKind2;
})(PatientLogoutKind || {});
var LogoutKind = /* @__PURE__ */ ((LogoutKind2) => {
  LogoutKind2["MANUAL"] = "MANUAL_LOGOUT";
  LogoutKind2["AUTO"] = "AUTO_LOGOUT";
  LogoutKind2["EXPIRED"] = "TOKEN_EXPIRED";
  LogoutKind2["DELETION"] = "USER_ACCOUNT_DELETION";
  LogoutKind2["PHONE_NUMBER_CHANGED"] = "PHONE_NUMBER_CHANGED";
  LogoutKind2["PHONE_NUMBER_CHANGE_TOKEN_EXPIRED"] = "PHONE_NUMBER_CHANGE_TOKEN_EXPIRED";
  return LogoutKind2;
})(LogoutKind || {});
const useLogout = (params) => {
  const kind = (params && params.kind) ?? "MANUAL_LOGOUT";
  const securityConfig = useSecurityConfig();
  const setCredentials = useSetCredentials();
  const { token } = useCredentials();
  const history = useHistory();
  return () => logout({ token: token ?? null, kind }).finally(() => {
    setCredentials(null, "local");
    setCredentials(null, "session");
    history.push(securityConfig.loginPath);
  });
};
export {
  LogoutKind,
  PatientLogoutKind,
  useLogout
};
